<div class="layout">
  @if (!hideNavbar) {
    <app-navbar-vertical></app-navbar-vertical>
  }
  <div class="page-content">
    <!-- Your router-outlet or other content -->
    <router-outlet></router-outlet>
  </div>
</div>
<p-toast position="top-right" />
